module.exports = __webpack_public_path__ + "static/img/icon-step2.ccf0f7c9.png";